import { useMutation, useQueryClient } from "@tanstack/react-query";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import WatchlistDomain from "watchlist/domainActions/WatchlistDomain";
import { WATCHLIST_STATUS_QUERY_KEY } from "watchlist/api/watchlist";
import watchlists from "security-content/mappings/watchlists";
const watchlistNameFor = (watchlistFieldType) => {
  var _a, _b;
  return (_b = (_a = Object.values(watchlists).find(({ fieldType }) => fieldType === watchlistFieldType)) == null ? void 0 : _a.title) != null ? _b : watchlistFieldType;
};
const useWatchlistMutations = () => {
  const queryClient = useQueryClient();
  const sendTelemetry = useSendTelemetry();
  const invalidateStatus = () => queryClient.invalidateQueries({ queryKey: WATCHLIST_STATUS_QUERY_KEY });
  const add = useMutation({
    mutationFn: ({ watchlistFieldType, value }) => WatchlistDomain.update(watchlistFieldType, value),
    onSuccess: (_data, { watchlistFieldType }) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.WATCHLIST.ENTRIES_ADDED, {
        app_action_value: "watchlist-entries-added",
        event_details: { watchlist_name: watchlistNameFor(watchlistFieldType), entry_count: 1 }
      });
      invalidateStatus();
    }
  });
  const remove = useMutation({
    mutationFn: ({ watchlistFieldType, value }) => WatchlistDomain.delete(watchlistFieldType, value),
    onSuccess: (_data, { watchlistFieldType }) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.WATCHLIST.ENTRIES_DELETED, {
        app_action_value: "watchlist-entries-deleted",
        event_details: { watchlist_name: watchlistNameFor(watchlistFieldType), entry_count: 1 }
      });
      invalidateStatus();
    }
  });
  return {
    addToWatchlist: add.mutateAsync,
    removeFromWatchlist: remove.mutateAsync
  };
};
export default useWatchlistMutations;
